import React, { useRef } from "react";
import html2pdf from "html2pdf.js";
import "./StudentResultCardReportPdfStyles.css";
import logo from "../../assets/img/logo-full.png";
import studentImage from "../../assets/img/generic/student-girl.jpg";

const StudentResultCardReportPdfGenerator = ({ reportData }) => {
  const pdfRef = useRef();

  const generatePdf = () => {
    const element = pdfRef.current;

    // Configure PDF options
    const options = {
      margin: [0, 0.2, 0, 0.2],
      filename: "student-result-card.pdf",
      image: { type: "jpeg", quality: 1 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "A4", orientation: "portrait" },
    };

    // Generate PDF
    html2pdf()
      .set(options)
      .from(element)
      .outputPdf("blob") // Output the PDF as a blob
      .then((pdfBlob) => {
        // Create a URL for the Blob
        const pdfUrl = URL.createObjectURL(pdfBlob);

        // Open the PDF in a new tab
        window.open(pdfUrl, "_blank");
      });
  };

  return (
    <>
      <div className="pdf-content">
        <div className="d-flex align-items-center">
          <h5 className="">Report Preview</h5>
          <button
            onClick={generatePdf}
            className="btn btn-danger btn-sm ms-auto"
          >
            Open PDF
          </button>
        </div>

        <hr />

        <div ref={pdfRef}>
          {reportData.map((singleItem, index) => (
            <>
              <div
                className="result-card-wrapper d-flex flex-column"
                key={index}
              >
                <div className="row mb-3 mt-3">
                  <div className="col-12 text-center">
                    <h3 className="mb-2">Student Result Card</h3>
                    <h4>{singleItem.organizationName}</h4>
                    <h6>{singleItem.centerName}</h6>
                  </div>
                </div>

                <div className="row mb-5">
                  <div className="col-8">
                    <div className="student-info">
                      <p>
                        <span className="title">Student:</span>
                        <span className="value">{singleItem.studentName}</span>
                      </p>
                      <p>
                        <span className="title">Roll Number:</span>
                        <span className="value">{singleItem.centerName}</span>
                      </p>
                      <p>
                        <span className="title">Term:</span>
                        <span className="value">{singleItem.termName}</span>
                      </p>
                      <p>
                        <span className="title">Class - Section:</span>
                        <span className="value">{singleItem.classSection}</span>
                      </p>
                    </div>
                  </div>
                  <div className="col-4 text-end">
                    <div className="student-picture">
                      {singleItem.imagePath &&
                        (() => {
                          const imageUrl =
                            process.env.REACT_APP_LIVE_DOMAIN_URL +
                            "/ExternalImages" +
                            singleItem.imagePath;
                          return <img src={imageUrl} alt="student-picture" />;
                        })()}
                    </div>
                  </div>
                </div>

                <table className="table custom-table table-bordered border-2 border-secondary">
                  <thead class="bg-light">
                    <tr>
                      <th>Subject</th>
                      <th>Total Marks</th>
                      <th>Obtained Marks</th>
                      <th>Grade</th>
                    </tr>
                  </thead>
                  <tbody className="">
                    {singleItem.resultDetail.map((item, index) => (
                      <tr key={index}>
                        <td>{item.subjectName}</td>
                        <td>{item.totalMarks}</td>
                        <td>{item.obtainedMarks}</td>
                        <td>N/A</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <div className="border border-secondary py-3 px-3 mt-auto mb-3">
                  <h6 className="mb-2 fs-8">Grading System</h6>
                  <div className="row row-cols-2 fs-9 fw-semibold">
                    <div className="col">A = 80-90%</div>
                    <div className="col">B = 80-90%</div>
                    <div className="col">C = 80-90%</div>
                    <div className="col">D = 80-90%</div>
                    <div className="col">E = 80-90%</div>
                    <div className="col">F = 80-90%</div>
                  </div>
                </div>
              </div>
            </>
          ))}
        </div>
      </div>
    </>
  );
};

export default StudentResultCardReportPdfGenerator;
